import { AuthenticatedSauceLabDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type { SauceLabDataRequestHeader } from '@eggplant/types'

interface Props {
  onError?: () => void
  onSuccess?: (response: string[]) => void
  children?: (response: string[]) => ReactElement
  shortErrorMessage?: string
  dataCenter: string
  sauceLabsAuthHeader: SauceLabDataRequestHeader
}

const GetSauceLabsDevicePlatformNames = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  dataCenter,
  sauceLabsAuthHeader
}: Props) => {
  const {
    apiKey,
    connectionId,
    sutId,
    userName
  } = sauceLabsAuthHeader

  const url = `${SUT_SERVICE}/sauce_labs/data_centers/${dataCenter}/device_platforms`

  return (
    <AuthenticatedSauceLabDataRequest
      apiKey={apiKey}
      children={children}
      connectionId={connectionId}
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      sutId={sutId}
      url={url}
      userName={userName}
    />
  )
}

export default GetSauceLabsDevicePlatformNames
